import type { Dispatch, SetStateAction } from 'react';
import { generatePath } from 'react-router-dom';

import type { ReportOrderStatusOrSentinel } from 'src/constants/report';
import { NO_BACKOFF_RESULT, ReportOrderStatus } from 'src/constants/report';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

export const orderReport = (
  setOrderStatus: Dispatch<SetStateAction<ReportOrderStatusOrSentinel>>,
  setPendingReportIds: Dispatch<SetStateAction<number[]>>,
  reportId: number,
  endpoint: string = apiPaths.ORDER_REPORT,
) => {
  setOrderStatus(ReportOrderStatus.ORDERED);
  HttpService.patch(generatePath(endpoint, { id: reportId }), {})
    .then((_) => {
      setOrderStatus(ReportOrderStatus.IN_PRODUCTION);
      setPendingReportIds((prevState) =>
        prevState.includes(reportId) ? prevState : [...prevState, reportId],
      );
    })
    .catch((_) => {
      setOrderStatus(ReportOrderStatus.ERROR);
    });
};

export const reportStatusRefresh = (
  setOrderStatus: Dispatch<SetStateAction<ReportOrderStatusOrSentinel>>,
  setFile: Dispatch<SetStateAction<string>>,
  reportId: number,
  endpoint: string = apiPaths.REPORT_ORDER_STATUS,
) => {
  // set order status to be able to show a loading indicator while waiting for the request
  setOrderStatus(ReportOrderStatus.IN_PRODUCTION);
  HttpService.get(endpoint, {
    report_ids: reportId.toString(),
  }).then(({ data }) => {
    if (data[reportId]?.order_status === ReportOrderStatus.CREATED) {
      setFile(data[reportId].file || '');
      setOrderStatus(ReportOrderStatus.CREATED);
    } else {
      // reset the order status to the unknown state so the user can refresh again
      setOrderStatus(NO_BACKOFF_RESULT);
    }
  });
};
